import type { Locale } from "@/lib/i18n";
import { pl, type CFaqTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const cFaqTranslations: Record<Locale, CFaqTranslations> = {
  pl,
  en,
  de,
};

export type { CFaqTranslations };
